export default __webpack_public_path__ + "static/img10-4c45aa755de48b9106f0674a25eca9b2.png";